import { Component } from '@angular/core';
import { ComboService } from '../../../Model/Combo/combo.service';
import { CommonService } from '../../../Model/Common/common.service';
import { DownloadSampleService } from '../../../Model/DownloadSample/download-sample.service';
import { ReportsService } from '../../../Model/Reports/reports.service';
import { UtilityService } from '../../../Model/utility/utility.service';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { SessionService } from '../../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import moment from 'moment';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule, NgbDatepickerModule, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-common-report',
  standalone: true,
  imports: [NgbModule, FormsModule, ReactiveFormsModule, NgSelectModule, CommonModule, NgbDatepickerModule, LoaderComponent],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './common-report.component.html',
  styleUrl: './common-report.component.scss'
})
export class CommonReportComponent {
  isDisabled: boolean = false;
  ReportIndex = null as any;
  ReportTypes = [
    { SelectType: '', Name: '' },
    { SelectType: 'AdminWiseAttendanceReport', Name: 'Monthly Attendance Report', type: 'Admin' },
    { SelectType: 'AdminWiseDuplicateAttendanceReport', Name: 'Duplicate Attendance Report', type: 'Admin' },
    { SelectType: 'LeaveDetailFront', Name: 'Monthly Leave Details Report', type: 'Admin' },
    { SelectType: 'AdminWiseOptionalHolidayReport', Name: 'Optional Holiday Report', type: 'Admin' },
    { SelectType: 'AdminWiseRegularizationReport', Name: 'Monthly Regularization Details Report', type: 'Admin' },
    { SelectType: 'AdminWiseAppInstallationReport', Name: 'ESS Installed Employee Report', type: 'Admin', ShowApprovalType: false },
    { SelectType: '', Name: 'Force Check Out Utility', type: 'Admin' },
    { SelectType: 'AdminWiseDuplicateIMEIReport', Name: 'Duplicate Device Punching Details Report', type: 'Admin', FromDateLabel: 'Attendance Date', ShowToDate: false, ShowApprovalType: false, },
    { SelectType: 'AdminWiseLeaveReport', Name: 'Monthly Leave Details Report', type: 'Admin' },
    { SelectType: 'EmpWiseAttendanceReport', Name: 'Monthly Attendance Report', type: 'Employee' },
    { SelectType: 'EmpWiseLeaveReport', Name: 'Monthly Leave Details Report', type: 'Employee' },
    { SelectType: 'EmpWiseOptionalHolidayReport', Name: 'Optional Holiday Report', type: 'Employee' },
    { SelectType: 'EmpWiseRegularizationReport', Name: 'Monthly Regularization Details Report', type: 'Employee' },
    { SelectType: 'ReimbursementReport', Name: 'Reimbursement Report', type: 'Admin' },
    { SelectType: 'EmployeeDurationReport', Name: 'Employee Duration Report', type: 'Admin' },
    { SelectType: 'MISReport', Name: 'MISReport', type: 'Admin' },
    { SelectType: 'MusterAttendancePOCMailReport', Name: 'Muster Attendance POC Mail Report', type: 'Admin' },
    { SelectType: 'OutdoorReport', Name: 'Outdoor Report', type: 'Admin' },
    { SelectType: 'PeriodicAttendanceMisReport', Name: 'Periodic Attendance Mis Report', type: 'Admin', ShowApprovalType: false },
    { SelectType: 'MusterAttendancePOCMailHistoryReport', Name: 'Muster Attendance POC Mail History Report', type: 'Admin' },
    { SelectType: 'CostSheetReport', Name: 'Cost Sheet Report', type: 'Admin' },
    { SelectType: 'ApprovalPendingRequestsReport', Name: 'Approval Pending Requests Report', type: 'Admin' },
    { SelectType: 'ProxyAttendanceReport', Name: 'Proxy Attendance Report', type: 'Admin' },
    { SelectType: 'AdminWiseLetterDetailsReport', Name: 'Admin Wise Letter Details Report', type: 'Admin' },
  ]
  user = [] as any;
  Branchs = [] as any;
  Clients = [] as any;
  Sites = [] as any;
  ReimbursementLoad = [] as any;
  YearLoad = [] as any;
  MISReportType = [] as any;
  ReimbursementClaimType = [{label: 'CTC'}, {label: 'Non CTC'}]
  SiteList = '';

  Filter = {
    SelectType: null as any,
    UserId: 0,
    FromDate: null as any,
    FromDateObj: null as any,
    ToDate: null as any,
    ToDateObj: null as any,
    ApprovalStatus: 'ALL',
    BranchId: null,
    SiteId: null,
    ClientId: null,
    EmpCode: null,
    EmpType: null as any,
    ESS_ReimbursementTypeId: null as any,
    ReimbursementType: '',
    FinancialYear: null as any,
    EmpMasterID: '',
    MonthName: null as any,
    FromMonth: null as any,
    ToMonth: null as any,
    MISReportType: null as any,
    ReimbursementClaimType: null as any
  }

  constructor(
    private session: SessionService,
    private comboload: ComboService,
    private toast: ToastService,
    protected common: CommonService,
    private download: DownloadSampleService,
    private report: ReportsService,
    private utility: UtilityService,
    private dateFormat: CustomDateParserFormatter,
    private router: Router,
    private route: ActivatedRoute,
    private tooltip: TooltipService
  ) {
    this.route.params.subscribe(params => this.ReportIndex = parseInt(params['id']));
    this.route.params.subscribe(params => this.Filter.EmpType = params['type'] == 'f' ? 'Front' : params['type'] == 'b' ? 'Back' : params['type'] == 'e' ? 'Employee' : '');
    this.user = this.session.GetUserDetails();
    this.common.getPageRights();
  }

  ngOnInit() {
    this.Filter.UserId = this.user.UserId;
    this.Filter.SelectType = this.ReportTypes[this.ReportIndex].SelectType;
    // console.log(this.Filter.SelectType);
    // console.log(this.Filter.EmpType);
    this.SelectDate('RegistrationDate', null, null);
    this.ComboLoad('Branch');
    this.ComboLoad('ReimbursementType');
    this.ComboLoad('FinancialYear');
    this.ComboLoad('ESS_MISReportTypeMaster');
  }


  ExcelDump() {
    if ((this.common.ToLowerCase(this.Filter.EmpType) == 'front' || this.common.ToLowerCase(this.Filter.EmpType) == 'back') && this.Filter.SelectType === 'ReimbursementReport') {
      this.ReimbussementReport();
    } else if (this.common.ToLowerCase(this.Filter.EmpType) == 'front' || this.common.ToLowerCase(this.Filter.EmpType) == 'back' && this.Filter.SelectType !== 'ReimbursementReport') {
      this.ESS_AdminWiseDetails();
    } else if (this.common.ToLowerCase(this.Filter.EmpType) == 'employee') {
      this.ESS_EmpWiseDetails();
    }
  }

  ESS_AdminWiseDetails() {
    if (this.Filter.FromDateObj == null) {
      this.toast.show({ message: 'Please select from date', type: toastTypeEnum.danger });
    } else if (this.Filter.ToDateObj == null) {
      this.toast.show({ message: 'Please select to date', type: toastTypeEnum.danger });
    } else if (this.Filter.ApprovalStatus == null) {
      this.toast.show({ message: 'Please select approval type', type: toastTypeEnum.danger });
    } else if ((this.ReportTypes[this.ReportIndex].ShowToDate ?? true) && (moment(this.dateFormat.format(this.Filter.ToDateObj), 'DD MMM YYYY').isBefore(moment(this.dateFormat.format(this.Filter.FromDateObj), 'DD MMM YYYY')))) {
      this.toast.show({ message: this.tooltip.Message.FromDateToDateMessgae, type: toastTypeEnum.danger });
    } else {
      this.isDisabled = true;
      this.Filter.FromDate = this.dateFormat.format(this.Filter.FromDateObj);
      if ((this.ReportTypes[this.ReportIndex].ShowToDate ?? true)) {
        this.Filter.ToDate = this.dateFormat.format(this.Filter.ToDateObj);
      }
      this.report.ESS_AdminWiseDetails(this.Filter).subscribe({
        next: (response) => {
          try {
            if (response && response.Table && response.Table.length > 0) {
              this.download.exportToExcel(response.Table, this.ReportTypes[this.ReportIndex].Name);
            }
            else {
              this.toast.show({ message: 'Data not found!', type: toastTypeEnum.warning });
            }
            this.isDisabled = false;
          } catch (e) {
            this.isDisabled = false;
          }
        },
        complete() { },
        error(err) { },
      });
    }
  }

  ESS_EmpWiseDetails() {
    if (this.Filter.FromDateObj == null) {
      this.toast.show({ message: 'Please select from date', type: toastTypeEnum.danger });
    } else if (this.Filter.ToDateObj == null) {
      this.toast.show({ message: 'Please select to date', type: toastTypeEnum.danger });
    } else if (this.Filter.ApprovalStatus == null) {
      this.toast.show({ message: 'Please select approval type', type: toastTypeEnum.danger });
    } else if ((this.ReportTypes[this.ReportIndex].ShowToDate ?? true) && (moment(this.dateFormat.format(this.Filter.ToDateObj), 'DD MMM YYYY').isBefore(moment(this.dateFormat.format(this.Filter.FromDateObj), 'DD MMM YYYY')))) {
      this.toast.show({ message: this.tooltip.Message.FromDateToDateMessgae, type: toastTypeEnum.danger });
    } else {
      this.isDisabled = true;
      this.Filter.FromDate = this.dateFormat.format(this.Filter.FromDateObj);
      if ((this.ReportTypes[this.ReportIndex].ShowToDate ?? true)) {
        this.Filter.ToDate = this.dateFormat.format(this.Filter.ToDateObj);
      }
      this.report.ESS_EmpWiseDetails({ SelectType: this.Filter.SelectType, EmpMasterID: this.Filter.UserId, FromDate: this.Filter.FromDate, ToDate: this.Filter.ToDate }).subscribe({
        next: (response) => {
          try {
            if (response && response.Table && response.Table.length > 0) {
              this.download.exportToExcel(response.Table, this.ReportTypes[this.ReportIndex].Name);
            }
            else {
              this.toast.show({ message: 'Data not found!', type: toastTypeEnum.warning });
            }
            this.isDisabled = false;
          } catch (e) {
            this.isDisabled = false;
          }
        },
        complete() { },
        error(err) { },
      });
    }
  }

  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    this.isDisabled = true;
    return this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        if (SelectType == 'RegistrationDate') {
          this.Filter.FromDateObj = this.dateFormat.parse(response.Table[0].RegistrationDate);
          this.Filter.ToDateObj = this.dateFormat.parse(response.Table[0].RegistrationDate);

          this.Filter.FromDateObj.day = 1;
          this.Filter.ToDateObj.day = parseInt(moment(response.Table[0].RegistrationDate).endOf('month').format('D'));
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ComboLoad(Combotype: String) {
    this.isDisabled = true;
    if (Combotype == 'Branch') {
      this.Branchs = [];
      this.Clients = [];
      this.Sites = [];

      this.Filter.ClientId = null;
      this.Filter.SiteId = null;
    } else if (Combotype == 'Client') {
      this.Clients = [];
      this.Sites = [];
      this.Filter.ClientId = null;
      this.Filter.SiteId = null;
    } else if (Combotype == 'Site') {
      this.Sites = [];
      this.Filter.SiteId = null;
    }
    this.comboload.ComboLoad({
      'Combotype': Combotype,
      'BranchId': (Combotype == 'Client' || Combotype == 'Site' || Combotype == 'Designation' || Combotype == 'Duty') ? this.Filter.BranchId : 0,
      'ClientId': (Combotype == 'Site' || Combotype == 'Designation' || Combotype == 'Duty') ? this.Filter.ClientId : 0,
      'SiteId': (Combotype == 'Designation' || Combotype == 'Duty') ? this.Filter.SiteId : 0,
      'EmpType': this.Filter.EmpType,
      'IsReport': true
    }).subscribe({
      next: (response) => {
        // console.log('res', response);
        if (Combotype == 'Branch') {
          this.Branchs = response.ComboLoad;
        } else if (Combotype == 'Client') {
          this.Clients = response.ComboLoad;
        } else if (Combotype == 'Site') {
          this.Sites = response.ComboLoad;
        } else if (Combotype == 'ReimbursementType') {
          this.ReimbursementLoad = response.ComboLoad;
          this.isDisabled = false
        } else if (Combotype == 'FinancialYear') {
          this.YearLoad = response.ComboLoad;
          // console.log('cb', this.YearLoad);
          this.isDisabled = false
        } else if (Combotype == 'ESS_MISReportTypeMaster') {
          this.MISReportType = response.ComboLoad;
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ReimbussementReport() {
    if (this.Filter.ESS_ReimbursementTypeId == null || this.Filter.ESS_ReimbursementTypeId === '') {
      this.toast.show({ message: 'Please select Reimbursement Type', type: toastTypeEnum.warning });
      return
    } else if (this.Filter.FinancialYear == null || this.Filter.FinancialYear === '') {
      this.toast.show({ message: 'Please select Financial Year ', type: toastTypeEnum.warning });
      return;
    } else if( this.Filter.ReimbursementClaimType == null || this.Filter.ReimbursementClaimType == ''){
      this.toast.show({ message: 'Please select Claim Type ', type: toastTypeEnum.warning });
      return;
    }
    const selected = this.ReimbursementLoad.find((site: { ESS_ReimbursementTypeID: any; }) => site.ESS_ReimbursementTypeID === this.Filter.ESS_ReimbursementTypeId);
    this.Filter.ReimbursementType = selected ? selected.ReimbursementType : null;
    const data = {
      SelectType: 'ReimbursementReport',
      FinancialYear: this.Filter.FinancialYear,
      Approvalstatus: this.Filter.ApprovalStatus,
      EmpMasterID: 0,
      ReimbursementType: this.Filter.ReimbursementType,
      Emptype: this.Filter.EmpType,
      IsNonCTC_Claim: this.Filter.ReimbursementClaimType == 'CTC' ? false: true
    }
    this.isDisabled = true;
    this.report.ESS_Reimbursement(data).subscribe(
      data => {
        if (data && data.Table && data.Table.length > 0) {
          this.download.exportToExcel(data.Table, this.ReportTypes[this.ReportIndex].Name);
          this.isDisabled = false
        }
        else {
          this.toast.show({ message: 'Data not found!', type: toastTypeEnum.warning });
          this.isDisabled = false
        }
        this.isDisabled = false
      });
  }

  close() {
    if (this.common.ToLowerCase(this.Filter.EmpType) === 'front') {
      this.router.navigate(['reports/frontreport']);
    }
    else if (this.common.ToLowerCase(this.Filter.EmpType) === 'back') {
      this.router.navigate(['reports/backreport']);
    }
  }

  onNavigate(event: any) {
    this.Filter.MonthName = {
      "year": event.next.year,
      "month": event.next.month,
      "day": 1
    }
  }

  async EmployeeDurationReport() {
    if (this.Filter.BranchId == null) {
      this.toast.show({ message: 'Select all the required fields', type: toastTypeEnum.warning });
      return;
    }
    if (this.Filter.SiteId == null) {
      await this.SitesList();
    }
    this.isDisabled = true;
    const detail = {
      BranchID: this.Filter.BranchId,
      IDs: this.Filter.EmpType == 'Back' ? 0 : this.Filter.SiteId == null ? this.SiteList : this.Filter.SiteId,
      MonthName: this.dateFormat.fullmonth[this.Filter.MonthName.month - 1],
      Year: this.Filter.MonthName.year,
      EmpType: this.Filter.EmpType
    }
    this.report.EmployeeDurationReport(detail).subscribe(
      data => {
        if (data.Code == "01") {
          window.open(data.FileName, '_blank')
        } else {
          this.toast.show({ message: data.FileName, type: toastTypeEnum.warning });
        }
        this.isDisabled = false
      },
      error => {
        console.error('Error:', error);
        this.isDisabled = false;
      }
    );
  }

  async MISReport() {
    if (this.Filter.MISReportType == null) {
      this.toast.show({ message: 'Select all the required fields', type: toastTypeEnum.warning });
      return;
    }
    if (this.Filter.SiteId == null) {
      await this.SitesList();
    }
    // console.log(this.SiteList);
    this.isDisabled = true;
    const detail = {
      SelectType: this.Filter.MISReportType,
      BranchID: this.Filter.BranchId,
      SiteMasterID: this.Filter.SiteId == null ? this.SiteList : this.Filter.SiteId,
      FromMonth: this.dateFormat.fullmonth[this.Filter.FromMonth.month - 1],
      FromYear: this.Filter.FromMonth.year,
      ToMonth: this.dateFormat.fullmonth[this.Filter.ToMonth.month - 1],
      ToYear: this.Filter.ToMonth.year,
      ServiceID: ''
    }
    this.report.MISReport(detail).subscribe({
      next: (response) => {
        // console.log('res', response);
        const reportData = response.Table;
        // console.log(data.Table[0]);
        console.log(reportData);
        if (reportData) {
          if (reportData.length == 0) {
            this.toast.show({ message: 'No Data Found', type: toastTypeEnum.warning })
          } else {
            // const jsonString = JSON.stringify(reportData);
            // const compressed = pako.deflate(jsonString);
            // const base64String = btoa(String.fromCharCode(...compressed));
            // const binaryString = atob(base64String);
            // const compressedData = Uint8Array.from(binaryString, c => c.charCodeAt(0));
            // const decompressedData = pako.inflate(compressedData, { to: 'string' });
            // const LogData = JSON.parse(decompressedData);
            this.download.exportInChunks(reportData, "MISReport");
          }
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  Download() {
    if (this.Filter.SelectType == 'EmployeeDurationReport') {
      this.EmployeeDurationReport();
    } else if (this.Filter.SelectType == 'MISReport') {
      this.MISReport();
    } else if (this.Filter.SelectType == 'MusterAttendancePOCMailReport') {
      this.MusterAttendancePOCMailReport('S');
    } else if (this.Filter.SelectType == 'OutdoorReport') {
      this.LoadOutdoorReport();
    } else if (this.Filter.SelectType == 'ReimbursementReport') {
      this.ReimbussementReport();
    } else if (this.Filter.SelectType == 'PeriodicAttendanceMisReport') {
      this.ESS_PeriodicAttendanceMisReport();
    } else if (this.Filter.SelectType == 'MusterAttendancePOCMailHistoryReport') {
      this.MusterAttendancePOCMailReport('H');
    } else if (this.Filter.SelectType == 'CostSheetReport') {
      this.CostSheetReport();
    } else if (this.Filter.SelectType == 'ApprovalPendingRequestsReport') {
      this.ESS_ApprovalPendingRequestsReport_OAS();
    } else if (this.Filter.SelectType == 'ProxyAttendanceReport') {
      this.ProxyAttendanceReportDownload('AdminWiseProxyAttendanceReport');
    } else if (this.Filter.SelectType == 'AdminWiseLetterDetailsReport'){
      this.ProxyAttendanceReportDownload('AdminWiseLetterDetailsReport');
    }

  }

  // SitesList() {
  //   this.isDisabled = true;
  //   this.comboload.ComboLoad({
  //     'Combotype': 'Site',
  //     'BranchId': this.Filter.BranchId,
  //     'ClientId': this.Filter.ClientId,
  //     'SiteId': this.Filter.SiteId,
  //     'EmpType': this.Filter.EmpType
  //   }).subscribe({
  //     next: (response) => {
  //       this.SiteList = response.ComboLoad.map((item: any) => item.SiteMasterID).join(',');
  //       console.log(this.SiteList);
  //     },
  //     complete: () => {
  //       this.isDisabled = false;
  //     },
  //     error: (error) => {
  //       this.isDisabled = false;
  //     },
  //   });
  // }

  SitesList(): Promise<any> {
    // this.isDisabled = true;
    return new Promise((resolve, reject) => {
      this.comboload.ComboLoad({
        'Combotype': 'Site',
        'BranchId': this.Filter.BranchId,
        'ClientId': this.Filter.ClientId,
        'SiteId': this.Filter.SiteId,
        'EmpType': this.Filter.EmpType
      }).subscribe({
        next: (response) => {
          this.SiteList = response.ComboLoad.map((item: any) => item.SiteMasterID).join(',');
          // console.log(this.SiteList);
          // this.isDisabled = false;
          resolve(true); // Resolve after data is loaded
        },
        error: (err) => {
          // this.isDisabled = false;
          reject(err);
        }
      });
    });
  }


  MusterAttendancePOCMailReport(selecttype: string) {
    // if (this.Filter.BranchId == null) {
    //   this.toast.show({ message: 'Select all the required fields', type: toastTypeEnum.warning });
    //   return;
    // }
    const detail = {
      SelectType: selecttype,
      BranchId: this.Filter.BranchId,
      ClientId: this.Filter.ClientId,
      SiteId: this.Filter.SiteId,
      MonthName: this.dateFormat.fullmonth[this.Filter.MonthName.month - 1],
      YearName: this.Filter.MonthName.year,
    }
    this.report.MusterAttendancePOCMailReport(detail).subscribe({
      next: (response) => {
        const reportData = response.Table;
        if (reportData) {
          if (reportData.length == 0) {
            this.toast.show({ message: 'No Data Found', type: toastTypeEnum.warning })
          } else {
            this.download.exportToExcelWithProgress(reportData, "Muster Attendance POC Report");
          }
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  LoadOutdoorReport() {
    if (!this.Filter.FromDateObj) {
      this.toast.show({ message: 'Please select From Date', type: toastTypeEnum.warning });
      return;
    }
    if (!this.Filter.ToDateObj) {
      this.toast.show({ message: 'Please select To Date', type: toastTypeEnum.warning });
      return;
    }
    if (!this.Filter.ApprovalStatus || this.Filter.ApprovalStatus == '') {
      this.toast.show({ message: 'Please select Approval Status!', type: toastTypeEnum.warning });
      return;
    }
    this.user = this.session.GetUserDetails();
    this.Filter.FromDate = this.dateFormat.format(this.Filter.FromDateObj);
    this.Filter.ToDate = this.dateFormat.format(this.Filter.ToDateObj);

    const logdataselect = {
      SelectType: 'AdminWiseOutdoorReport',
      UserId: this.user.UserId,
      FromDate: this.Filter.FromDate,
      ToDate: this.Filter.ToDate,
      ApprovalStatus: this.Filter.ApprovalStatus,
      BranchId: this.Filter.BranchId,
      SiteId: this.Filter.SiteId,
      ClientId: this.Filter.ClientId,
      EmpType: 'Front',
      EmpCode: this.Filter.EmpCode
    }
    this.isDisabled = true;
    this.report.ESS_AdminWiseDetails(logdataselect).subscribe(
      data => {
        if (data && data.Table && data.Table.length > 0) {
          // this.LogData = Object.values(data.Table);
          this.download.exportToExcel(data.Table, "OutdoorReport");
          this.isDisabled = false;
        }
        else {
          this.isDisabled = false;
          this.toast.show({ message: 'Data not found!', type: toastTypeEnum.warning });
        }
      },
      error => {
        console.error('Error:', error);
        this.isDisabled = false;
      }
    );
  }

  ESS_PeriodicAttendanceMisReport() {
    if (this.Filter.FromDateObj == null) {
      this.toast.show({ message: 'Please select From Date', type: toastTypeEnum.warning });
      return;
    } else if (this.Filter.ToDateObj == null) {
      this.toast.show({ message: 'Please select To Date', type: toastTypeEnum.warning });
      return;
    }
    this.Filter.FromDate = this.dateFormat.format(this.Filter.FromDateObj);
    this.Filter.ToDate = this.dateFormat.format(this.Filter.ToDateObj);
    this.isDisabled = true;
    this.report.ESS_PeriodicAttendanceMisReport({
      'FromDate': this.Filter.FromDate, 'ToDate': this.Filter.ToDate,
      'BranchId': this.Filter.BranchId, 'SiteId': this.Filter.SiteId, 'ClientId': this.Filter.ClientId
    }).subscribe({
      next: (response: Blob) => {
        this.common.handleDownload(response, 'FrontEmployeeAttenanceReport.xlsx');
        this.isDisabled = false;
      },
      complete: () => { this.isDisabled = false; },
      error: (error) => {
        this.toast.show({ message: error.error.message, type: toastTypeEnum.warning })
        console.log(error);
        this.isDisabled = false;
      },
    });
  }


  CostSheetReport() {
    if (this.Filter.BranchId == null || this.Filter.BranchId == '') {
      this.toast.show({ message: 'Please select Branch', type: toastTypeEnum.warning });
      return;
    }
    if (this.Filter.ClientId == null || this.Filter.ClientId == '') {
      this.toast.show({ message: 'Please select Client', type: toastTypeEnum.warning });
      return;
    }
    this.isDisabled = true;
    this.report.CostSheetReport({
      BranchID: this.Filter.BranchId,
      ClientID: this.Filter.ClientId,
      SiteID: this.Filter.SiteId,
      MonthYearName: this.dateFormat.fullmonth[this.Filter.MonthName.month - 1] + ' ' + this.Filter.MonthName.year
    }).subscribe({
      next: (response) => {
        const reportData = response.Table;
        if (reportData) {
          if (reportData.length == 0) {
            this.toast.show({ message: 'No Data Found', type: toastTypeEnum.warning })
          } else {
            this.download.exportToExcelWithProgress(reportData, "Cost Sheet Report");
          }
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.toast.show({ message: error.error.message, type: toastTypeEnum.warning })
        console.log(error);
        this.isDisabled = false;
      },
    });
  }

  ESS_ApprovalPendingRequestsReport_OAS() {
    if (this.Filter.BranchId == null || this.Filter.BranchId == '') {
      this.toast.show({ message: 'Please select Branch', type: toastTypeEnum.warning });
      return;
    }
    if (this.Filter.ClientId == null || this.Filter.ClientId == '') {
      this.toast.show({ message: 'Please select Client', type: toastTypeEnum.warning });
      return;
    }
    if (this.Filter.SiteId == null || this.Filter.SiteId == '') {
      this.toast.show({ message: 'Please select Site', type: toastTypeEnum.warning });
      return;
    }
    this.isDisabled = true;
    this.report.ApprovalPendingRequestsReport({
      SelectType: 'PendingReq',
      SiteMasterId: this.Filter.SiteId,
      MonthName: this.dateFormat.fullmonth[this.Filter.MonthName.month - 1],
      YearName: this.Filter.MonthName.year,
    }).subscribe({
      next: (response) => {
        const reportData = response.Table;
        if (reportData) {
          if (reportData.length == 0) {
            this.toast.show({ message: 'No Data Found', type: toastTypeEnum.warning })
          } else {
            this.download.exportToExcelWithProgress(reportData, "Approval Pending Requests Report");
          }
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.toast.show({ message: error.error.message, type: toastTypeEnum.warning })
        console.log(error);
        this.isDisabled = false;
      },
    });
  }

  ProxyAttendanceReportDownload(SelectType: any) {
    this.isDisabled = true;
    this.Filter.FromDate = this.dateFormat.format(this.Filter.FromDateObj);
    this.Filter.ToDate = this.dateFormat.format(this.Filter.ToDateObj);
    this.report.ESS_AdminWiseDetailsCompress({
      SelectType: SelectType,
      UserId: this.user.UserId,
      FromDate: this.Filter.FromDate,
      ToDate: this.Filter.ToDate,
      ApprovalStatus: 'All',
      BranchId: this.Filter.BranchId,
      SiteId: this.Filter.SiteId,
      ClientId: this.Filter.ClientId,
      EmpType: this.Filter.EmpType,
      EmpCode: ''
    }).subscribe({
      next: (response: Blob) => {debugger
        if((response as any)?.Error_Code){
          this.toast.show({message: 'No Data Found', type: toastTypeEnum.warning});
          return;
        }
        this.handleDownload(response, 'Proxy Attendance Report.xlsx');
        this.isDisabled = false;
        
      },
      complete: () => { this.isDisabled = false; },
      error: (error) => {
        this.toast.show({ message: error.error.message, type: toastTypeEnum.warning })
        console.log(error);
        this.isDisabled = false;
      },
    });
  }

  private handleDownload(blob: Blob, filename: string) {
    saveAs(blob, filename);
  }
}